import React from 'react';
import { useSelector } from 'react-redux';

import { BettingWrapper, Skeleton } from 'app/modules/Betting';

import $betting from '../../contexts/betting/$live';
import { LiveContent } from './LiveContent';
import { entityLoading, matchIds as entityMatchIds } from './selectors/entities';

const Live = () => {
  const loading = useSelector(entityLoading);
  const matchIds = useSelector(entityMatchIds);

  const isMatchesLoading = loading && matchIds.size <= 0;

  if (isMatchesLoading) {
    return (
      <Skeleton />
    );
  }

  return (
    <BettingWrapper context={$betting}>
      <LiveContent />
    </BettingWrapper>
  );
};

export default Live;
